import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Breadcrumb, BreadcrumbService } from 'angular-crumbs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {
  pageTitle!:string;
  isDisplay:boolean =true;

  constructor(private titleService: Title,
              private breadcrumbService: BreadcrumbService,
              private router:Router) { }

  ngOnInit(): void {
     this.breadcrumbService.breadcrumbChanged.subscribe((crumbs) => {
        this.titleService.setTitle(this.createTitle(crumbs));
     });
  }

  private createTitle(routesCollection: Breadcrumb[]) {
      var days = '';
      const title = 'Global Agricultural Information Network';
      if(routesCollection.length > 0)
      {
        if (routesCollection[0].route.path.includes('quick-links'))
        {
          days = routesCollection[0].url.split('/').pop();
          if(days == '1')
          {
            routesCollection[0].displayName = 'Today\'s Reports';
          }
          else if(days == '30')
          {
            routesCollection[0].displayName = 'Past Month\'s Reports';
          }
          else
          {
            routesCollection[0].displayName = 'Past ' + days + ' Days Reports';
          }
        }
      }
      const titles = routesCollection.filter((route) => route.displayName);

      if (!titles.length) { this.pageTitle =title ;return title; }
      else{ this.pageTitle = titles[titles.length-1].displayName;}

      const routeTitle = this.titlesToString(titles);
      return `${routeTitle} ${title}`;
  }

  private titlesToString(titles: any) {
      return titles.reduce((prev: any, curr: any) => {
          return `${curr.displayName} | ${prev}`;
      }, '');
  }

}
